import axios from './api';

export const getMyBacklog = () => (
  axios.request({
    method: 'GET',
    url: '/hourapp/getMyBacklog',
  })
);

export const getMyActiveCase = () => (
  axios.request({
    method: 'GET',
    url: '/hourapp/getMyActiveCase',
  })
);

export const getMyCaseInfo = () => (
  axios.request({
    method: 'GET',
    url: '/hourapp/getMyCaseInfo',
  })
);
